import * as React from 'react'
import {
    Toggle, Logo, LogoTypes
} from 'DVWebNodeUI'
import * as st from './Filter.module.scss'
import * as cn from 'classnames'
import { FilterToggle } from '@utils'
import { FilterConditionalToolip } from './FilterTooltip'
import { counter } from '../../../../../util/csm/csm'



export interface FilterProps extends FilterToggle {
    filterToggle?: () => void
    filterOn?: boolean
    className?: string
    isSticky?: boolean
}

const SESSION_STORAGE_KEY = "storefrontEntitledFilterOn"

const checkSessionStorage = () => {
    const currentValue = !global.__SERVER__ && window && window.sessionStorage &&
        window.sessionStorage.getItem(SESSION_STORAGE_KEY)
    return Boolean(currentValue && currentValue === "true")
}

const setSessionStorage = (filterState: boolean) => {
    const value = filterState.toString()
    !global.__SERVER__ && window && window.sessionStorage &&
        window.sessionStorage.setItem(SESSION_STORAGE_KEY, value)
}

const convertToggleLabel = (label: string) => (label == "$PRIMELOGO" ?
    <Logo use={LogoTypes.prime} className={st.primeLogo}></Logo> :
    <span className={st.filterLabel}>{label}</span>)

export class Filter extends React.PureComponent<FilterProps> {
    constructor(props: FilterProps) {
        super(props)
    }

    componentDidMount() {
        const sessionStorageState = checkSessionStorage()
        if (sessionStorageState !== this.props.filterOn)
            this.props.filterToggle()
    }

    componentDidUpdate() {
        setSessionStorage(this.props.filterOn)
    }

    toggle() {
        const counterValue = this.props.filterOn ? 0 : 1
        counter("DVWeb::SF::EntitledToggle::Toggled", counterValue, false)
        this.props.filterToggle()
    }

    render() {
        const label = convertToggleLabel(this.props.label)
        const labelWithMaybeTooltip = <FilterConditionalToolip tooltipLabel={this.props.tooltip} className={st.tooltip}>
            {label}
        </FilterConditionalToolip>
        return <div
            className={cn(this.props.className, st.filter, { [st.isSticky]: this.props.isSticky })}>
            <Toggle onChange={() => this.toggle()} checked={this.props.filterOn} /> {labelWithMaybeTooltip}
        </div>
    }
}